import { Button, Card, Flex, Layout, List, Space, Spin, Steps, theme } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ActionService } from "../../services/ActionService";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { SFModal } from "../../components/elements/SFModal";
import ActionMail from "../../components/action/ActionMail";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { setPdfExportObject } from "../../store/SiteSlice";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import _ from "lodash";
import { mdlActionCreateParamPair } from "../../models/domain/value-objects/ActionCreateParamPair";
import { mdlKeyTitlePair } from "../../models/domain/value-objects/KeyTitlePair";
import { mdlSpoOfferDetailRequest } from "../../models/service-models/action/SpoOfferDetailRequest";
import { ActionWizardFirst } from "../../components/action/ActionWizardFirst";
import { ActionWizardSecond } from "../../components/action/ActionWizardSecond";
import { ActionListTable } from "../../components/action/ActionListTable";
import { mdlActionPricePairHolder } from "../../models/domain/value-objects/ActionPricePairHolder";
import { mdlSpoPreviewRequest } from "../../models/service-models/action/SpoPreviewRequest";
import { mdlSpoSaveRequest } from "../../models/service-models/action/SpoSaveRequest";
import { mdlSpoSendRequest } from "../../models/service-models/action/SpoSendRequest";
import dayjs from "dayjs";
import { mdlServiceResponse } from "../../models/service-models/common/ServiceResponse";
import { mdlBaseDataResponse } from "../../models/service-models/common/BaseDataResponse";
import { mdlSpoMailPreviewItem } from "../../models/domain/value-objects/SpoMailPreviewItem";
import { mdlSpoPreviewItem } from "../../models/domain/value-objects/SpoPreviewItem";
import { Content } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";
import utc from 'dayjs/plugin/utc';

export const ActionCreate = () => {
    dayjs.extend(utc);

    const { token } = theme.useToken();
    const { t } = useTranslation();
    const [current, setCurrent] = useState(0);
    const [createClicked, setCreateClicked] = useState<boolean>(false);
    const [selectedSpo, setSelectedSpo] = useState<string>();
    const [actionPairHolder, setActionPairHolder] = useState<mdlActionPricePairHolder>({ agencies: [] });
    const dispatch = useAppDispatch();
    const exportStatus = useAppSelector(x => x.site.exportStatus);
    const printStatus = useAppSelector(x => x.site.printStatus);
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [createParamPairs, setCreateParamPairs] = useState<mdlActionCreateParamPair[]>([]);
    const [openMailModal, setOpenMailModal] = useState<boolean>(false);
    const [marketAgencyPair, setMarketAgencyPair] = useState<mdlKeyTitlePair[]>();
    const [saveData, setSaveData] = useState<mdlSpoSaveRequest>();
    const [allMarket, setAllMarket] = useState<boolean>();
    const [mailPreviewData, setMailPreviewData] = useState<mdlServiceResponse<mdlBaseDataResponse<mdlSpoMailPreviewItem>>>();
    const [fetchedPreviewSpo, setFetchedPreviewSpo] = useState<string>();
    const [printLoading, setPrintLoading] = useState<boolean>(false);
    const [stageThirdPreviewData, setStageThirdPreviewData] = useState<mdlServiceResponse<mdlBaseDataResponse<mdlSpoPreviewItem>>>();
    const [clearCustomTransferData, setClearCustomTransferData] = useState<boolean>(false);
    const navigate = useNavigate();

    const {
        data: detailData,
        isLoading: detailLoading
    } = useQuery(
        ["getSpoDetail", selectedSpo],
        () => {
            if (selectedSpo) {
                var request: mdlSpoOfferDetailRequest = { id: selectedSpo };
                return ActionService.SpoOfferDetail(request);
            }
        },
        {
            onSuccess(data) {
                if (data?.body?.data) {
                    var marketAgencyMaps = _.first(data.body.data)?.marketAgencyMaps?.filter(x => x !== "");
                    var selectedHotel = _.first(data.body.data)?.hotelId;
                    var pairList = new Array<mdlActionCreateParamPair>();
                    _.each(data.body.data, function (d, i) {
                        var pair: mdlActionCreateParamPair =
                        {
                            index: i,
                            roomPrice: {
                                accomDateEnd: d.accomDateEnd,
                                accomDateStart: d.accomDateStart,
                                board: d.boardName,
                                roomType: d.roomTypeName,
                                boardId: d.boardId,
                                bodyMessage: d.bodyMessage,
                                currency: d.currency,
                                discountRate: d.discountRate,
                                footerMeesage: d.footerMeesage,
                                hotelId: d.hotelId,
                                hotelName: d.hotelName,
                                mailSubject: d.mailSubject,
                                price: d.price,
                                priceType: d.priceType,
                                roomTypeId: d.roomTypeId,
                                sellEndDate: d.sellEndDate,
                                sellStartDate: d.sellStartDate,
                                sendeName: d.sendeName,
                                senderShownName: d.senderShownName,
                                spoNote: d.spoNote,
                                spoType: d.spoType
                            },
                            spoMessage: {
                                bodyMessage: d.bodyMessage,
                                emailSubject: d.mailSubject,
                                footerMessage: d.footerMeesage,
                                hotelId: d.hotelId,
                                sendeName: d.sendeName,
                                senderShownName: d.senderShownName
                            }
                        }
                        pairList.push(pair);
                    })
                    //setSelectedHotel(selectedHotel);
                    setCreateParamPairs(pairList);
                    if (_.first(marketAgencyMaps)?.startsWith("_"))
                        setAllMarket(true);
                    else {
                        setAllMarket(false);
                    }
                    setActionPairHolder({ ...actionPairHolder, ["agencies"]: marketAgencyMaps?.map(x => Object.assign(x, { title: x.startsWith("_") ? `null${x}` : x, key: x.startsWith("_") ? `null${x}` : x })) as mdlKeyTitlePair[] })
                }
            },
            refetchOnWindowFocus: false,
            enabled: !!selectedSpo
        }
    );

    const { mutateAsync: save, isLoading: createLoading, data: createData } = useMutation(
        (request: mdlSpoSaveRequest) => ActionService.Save(request),
        {
            onMutate(variables) {
                if (!selectedSpo) {
                    variables.data!.id = "00000000-0000-0000-0000-000000000000";
                }
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body?.isSuccessful) {
                    setCurrent(current + 1);
                    setSelectedSpo(data.body?.message);
                    getSpoPreview();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const { mutateAsync: send, isLoading: sendLoading, data: sendData } = useMutation(
        (request: mdlSpoSendRequest) => ActionService.Send(request),
        {
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body?.isSuccessful) {
                    toast.success(t("common.success"));
                    navigate("/spo/history");
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const { mutateAsync: getSpoPreview, isLoading: previewLoading, data: previewData } = useMutation(
        async () => {
            if (saveData) {
                var request: mdlSpoPreviewRequest = { data: saveData.data };
                return ActionService.Preview(request).catch((error) => {
                    console.error("Query Function Error:", error);
                    throw error; // Ensure the error is re-thrown for React Query to handle it
                });
            }
            return undefined;
        },
        {
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                console.log("success");
            },
        }
    );

    // const {
    //     refetch: getSpoPreview,
    //     data: previewData,
    //     isLoading: previewLoading
    // } = useQuery(
    //     ["getSpoPreview", saveData],
    //     () => {
    //         if (saveData) {
    //             var request: mdlSpoPreviewRequest = { data: saveData.data };
    //             return ActionService.Preview(request).catch((error) => {
    //                 console.error("Query Function Error:", error);
    //                 throw error; // Ensure the error is re-thrown for React Query to handle it
    //             });
    //         }
    //         return undefined;
    //     },
    //     {
    //         onSuccess(data) {
    //             var a = 1;
    //         },
    //         onError(err) {
    //             console.log(err);
    //         },
    //         refetchOnWindowFocus: false,
    //         enabled: false
    //     }
    // );


    const handleMailCallback = () => {
        setOpenMailModal(false);
    }

    const handleSave = () => {
        if (createParamPairs == null) {
            toast.error(t("action.create.actionsEmptyError"));
            return;
        }
        else {
            var agencies = _.filter(actionPairHolder.agencies, function (f) {
                return (f as mdlKeyTitlePair).key?.includes("_");
            });

            var finalizeAgencies = agencies.map(x => (x as mdlKeyTitlePair)?.title?.replace("null_null_", "null_"));
            //finalizeAgencies = agencies.map(x => (x as string).startsWith("_") ? `null${x}` : x as string);

            var clonePairs = _.cloneDeep(createParamPairs);
            _.each(clonePairs, function (r) {
                if (!r.roomPrice!.key)
                    r.roomPrice!.key = `${r.roomPrice?.hotelId}__${r.roomPrice?.roomTypeId}__${r.roomPrice?.boardId}__0`;
            })

            var firstPair = _.first(createParamPairs);
            var request: mdlSpoSaveRequest = {
                data: {
                    marketAgencies: finalizeAgencies.map(x => (x as string).replace("_", "__")),
                    roomPrices: clonePairs.map(x => x.roomPrice!),
                    mailSubject: firstPair?.spoMessage?.emailSubject,
                    bodyMessage: firstPair?.spoMessage?.bodyMessage,
                    footerMeesage: firstPair?.spoMessage?.footerMessage,
                    isSend: false,
                    isCancel: false,
                    sendeName: firstPair?.spoMessage?.sendeName,
                    senderShownName: firstPair?.spoMessage?.senderShownName,
                    simpleSpecialOfferMessage: firstPair?.spoMessage,
                    spoName: "",

                    id: selectedSpo
                }
            }
            setSaveData(request);
            save(request);
        }
    }

    useEffect(() => {
    }, [detailData])

    const next = () => {
        if (current == 0 && actionPairHolder.agencies?.length == 0)
            toast.error(t("action.create.chooseAgency"));
        else {
            if (current == 1) {
                var validateRequiredFields = new Array<string>();
                _.each(createParamPairs, function (f) {
                    if (f.roomPrice?.priceType == undefined) {
                        validateRequiredFields.push(t("action.create.priceType"));
                    }
                    if (f.roomPrice?.price == undefined && f.roomPrice?.discountRate) {
                        validateRequiredFields.push(t("action.create.price"));
                        validateRequiredFields.push(t("action.create.discount"));
                    }
                    if (f.roomPrice?.currency == undefined) {
                        validateRequiredFields.push(t("action.create.currency"));
                    }
                    if (f.roomPrice?.price == 0 && f.roomPrice?.discountRate == 0) {
                        validateRequiredFields.push(t("action.create.priceOrDiscountMustHaveValue"));
                    }
                })

                if (createParamPairs == null || (createParamPairs != null && createParamPairs.length == 0))
                    validateRequiredFields.push(t("action.create.spoRequired"));

                if (validateRequiredFields.length == 0) {
                    handleSave();
                    //setCurrent(current + 1);
                }
                else {
                    toast.error(<>{t("action.create.actionValidationFailed")} <br /> {_.uniq(validateRequiredFields).join(",")}</>)
                }
            }
            else {
                setCurrent(current + 1);
            }
        }

    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const handleSend = () => {
        if (selectedSpo == null) {
            toast.error("common.spoRequired");
        }
        else {
            send({ spoId: selectedSpo });
        }
    }

    const handleSelectedHotel = (id: string) => {
        setSelectedHotel(id);
        setClearCustomTransferData(true);
        //clearActionPairHolder();
    }
    const clearActionPairHolder = () => {
        setActionPairHolder({ agencies: [] });
    }

    let steps = [
        {
            title: t("action.create.wizardFirst"),
            content:
                <ActionWizardFirst
                    marketAgencyPairSetter={setMarketAgencyPair}
                    agencies={actionPairHolder.agencies}
                    clearAgencyMarketData={clearActionPairHolder}
                    actionPricePair={actionPairHolder}
                    spoDetail={detailData}
                    allMarkets={allMarket}
                    isLoading={detailLoading}
                    actionCreateRequestSetter={setActionPairHolder}
                    parentChangeStatus={clearCustomTransferData}
                    parentChangeFunction={() => { setClearCustomTransferData(true) }}
                />
        },
        {
            title: t("action.create.wizardSecond"),
            content:
                <ActionWizardSecond
                    spoDetail={detailData}
                    actionPriceHolder={actionPairHolder}
                    selectedHotel={selectedHotel}
                    selectedHotelSetter={handleSelectedHotel}
                    createParamPairSetter={setCreateParamPairs}
                    createParamPairs={createParamPairs}
                />
        },
        {
            title: t("action.create.wizardThird"),
            content:
                <>
                    <Layout>
                        <Content>
                            <Card loading={previewLoading}>
                                {
                                    previewData && previewData.body && previewData.body.data && previewData.body.data.html
                                    &&
                                    <div dangerouslySetInnerHTML={{ __html: previewData.body.data.html }} />
                                }
                            </Card>
                        </Content>
                    </Layout>
                </>
        },
    ];

    const contentStyle: React.CSSProperties = {
        textAlign: 'center',
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };

    const items = steps.map((item) => ({ key: item.title, title: item.title }));

    const handleAddNew = () => {
        setSelectedSpo(undefined);
        setAllMarket(false);
        setCreateClicked(true);
    }

    const handlePrint = async (spoId?: string) => {
        var pSpoId = spoId;
        if (!spoId) {
            pSpoId = selectedSpo;
        }

        var content: string | undefined = "";

        if (pSpoId) {
            if (mailPreviewData && mailPreviewData.body && mailPreviewData.body.data && fetchedPreviewSpo && fetchedPreviewSpo === pSpoId) {
                content = mailPreviewData.body.data.previewHTML;
            }
            else {
                setPrintLoading(true);
                var data = await ActionService.MailPreview({ spoId: pSpoId });
                if (data && data.header && data.header.success) {
                    setFetchedPreviewSpo(pSpoId);
                    setMailPreviewData(data);
                    content = data.body?.data?.previewHTML;
                }
            }

            if (content) {
                let params = {};
                params = { htmlContent: content }
                var exportProps: mdlPDFRendererProps = {
                    params: params,
                    rendererType: enmPdfRendererType.ActionTemplate,
                    type: enmPdfExportType.PRINT,
                }
                setPrintLoading(false);
                dispatch(setPdfExportObject(exportProps));
            }
        }
    }

    const handleExport = async (spoId?: string) => {
        var pSpoId = spoId;
        if (!spoId) {
            pSpoId = selectedSpo;
        }

        var content: string | undefined = "";

        if (pSpoId) {
            if (mailPreviewData && mailPreviewData.body && mailPreviewData.body.data && fetchedPreviewSpo && fetchedPreviewSpo === pSpoId) {
                content = mailPreviewData.body.data.previewHTML;
            }
            else {
                setPrintLoading(true);
                var data = await ActionService.MailPreview({ spoId: pSpoId });
                if (data && data.header && data.header.success) {
                    setFetchedPreviewSpo(pSpoId);
                    content = data.body?.data?.previewHTML;
                    setMailPreviewData(data);
                }
            }

            if (content) {
                let params = {};
                params = { htmlContent: content }
                var exportProps: mdlPDFRendererProps = {
                    params: params,
                    rendererType: enmPdfRendererType.ActionTemplate,
                    type: enmPdfExportType.PDF,
                }
                setPrintLoading(false);
                dispatch(setPdfExportObject(exportProps));
            }
        }
    }

    const handleBack = () => {
        setCreateParamPairs([]);
        setActionPairHolder({});
        setCurrent(0);
        setCreateClicked(false);
        setSelectedSpo(undefined);
        setSelectedHotel(undefined);
    }

    const handleNewActionSendMail = () => {
        //setSelectedSpo(undefined);
        setOpenMailModal(true);
    }

    useEffect(() => { }, [printLoading])

    const handleMailView = async (spoId: string) => {
        setPrintLoading(true);
        var data = await ActionService.MailPreview({ spoId: spoId });
        if (data && data.header && data.header.success) {
            setMailPreviewData(data);
            setOpenMailModal(true);
        }
        setPrintLoading(false);
    }


    return (
        <>
            <Spin spinning={printLoading}>
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <PageHeaderSection
                                    pageTitle={t("action.create.title")}
                                    addNewFunction={!createClicked ? handleAddNew : undefined}
                                />
                                <div className="nk-block">
                                    <div className="row g-gs">
                                        <div className="col-12">
                                            {
                                                createClicked
                                                &&
                                                <Card className="card card-bordered" loading={createLoading || sendLoading || previewLoading}>
                                                    <Flex justify="end">
                                                        <Button type="default" onClick={handleBack}>{t("common.back")}</Button>
                                                    </Flex>
                                                    <div className="card-inner">
                                                        <Steps current={current} items={items} />
                                                        <div style={contentStyle}>{steps[current].content}</div>
                                                        <Flex justify="end">
                                                            <div style={{ marginTop: 24 }}>
                                                                <Space>

                                                                    {current > 0 && (
                                                                        <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                                                                            {t("action.create.previousPage")}
                                                                        </Button>
                                                                    )}
                                                                    {current < steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => next()}>
                                                                            {t("action.create.nextPage")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleSend()}>
                                                                            {t("action.create.send")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleNewActionSendMail()}>
                                                                            {t("action.create.sendMail")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handlePrint()}>
                                                                            {t("action.create.print")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleExport()}>
                                                                            {t("action.create.pdf")}
                                                                        </Button>
                                                                    )}
                                                                </Space>
                                                            </div>
                                                        </Flex>
                                                    </div>
                                                </Card>
                                            }

                                            {
                                                !createClicked
                                                &&
                                                <ActionListTable
                                                    handleMail={handleMailView}
                                                    handleExport={handleExport}
                                                    handlePrint={handlePrint}
                                                    createClickSetter={setCreateClicked}
                                                    createParamPairs={createParamPairs}
                                                    selectedSpoSetter={setSelectedSpo}
                                                    setOpenMailModal={setOpenMailModal}
                                                    createClicked={createClicked}
                                                    exportStatus={exportStatus}
                                                    printStatus={printStatus}
                                                    selectedSpo={selectedSpo}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
            <SFModal
                width={window.innerWidth * 70 / 100}
                open={openMailModal}
                toggler={() => { setOpenMailModal(!openMailModal) }}
                body={<ActionMail previewResponse={mailPreviewData} loading={printLoading} onClose={() => setOpenMailModal(false)} spoId={selectedSpo} callback={handleMailCallback} />}
                title={t("action.template.mailTitle")}
            />
        </>
    );
}
